import styled from 'styled-components'

export const StyledCheckBoxGroup = styled.div`
  display: grid;
  grid-template-columns: ${props => `repeat(${props.columns || 2}, auto)`};
`
